import { useStores } from 'Hooks/useStore';
import { useHistory } from 'react-router-dom';
import styles from '../Sidebar.module.scss';
import TenantSelection from './TenantSelection';
import { SystemRoleType } from 'Services/Api/Roles/Types';
import Icon from 'Components/Icon/Icon';
import { getAppRoutes } from 'Pages/App/App.constants';

type Props = {
    showDrawer: boolean,
    openDrawer: () => void;
}

const SidebarHeader = ({ showDrawer, openDrawer } : Props) => {
	const history = useHistory();
    const { authStore, systemsStore } = useStores();
	const isSuperAdmin = authStore.currentUser?.primarySystemRole?.role === SystemRoleType.SuperAdmin;

    return <div className={styles.mobile__header}>
        <div className={styles.icon__section}>
            <Icon type="hamburgerMenuIcon" onClick={openDrawer} />
            <Icon type="logoIcon" onClick={() => history.push(getAppRoutes().HOME)} />
        </div>
        {!isSuperAdmin && <TenantSelection {...{ isSuperAdmin, systemsStore, showNoSelection: false }} />}
    </div>
}

export default SidebarHeader;